module.exports = __webpack_public_path__ + "img/avatar2.b29cc4af.png";